<script setup lang="ts">
/**
 * UI-kit component
 * Category: Badges
 * Name: BadgeTutorCategory
 * FIGMA: https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=15835-95475
 */
import type { BadgeTutorCategoryProps } from '../types/interfaces'

import { useBadgeTutorCategory } from '../composables/use-badge-tutor-category.hook'
import { AppBadge } from '../../app-badge'

defineOptions({
  name: 'BadgeTutorCategory',
})

const props = defineProps<BadgeTutorCategoryProps>()

const {
  visible,
  color,
  text,
} = useBadgeTutorCategory({ props })
</script>

<template>
  <AppBadge
    v-if="visible"
    :color="color"
    :text="text"
  />
</template>
